(() => {
  const STORAGE_KEY = 'calinfiActiveOffer:v1';
  const PARAMETER_KEYS = ['offer', 'promo', 'discount_code'];

  function normalizeCode(value) {
    return String(value || '').trim().toUpperCase();
  }

  function readStoredOffer() {
    try {
      const stored = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
      const code = normalizeCode(stored?.code);
      return code ? { code, activatedAt: Number(stored.activatedAt || Date.now()) } : null;
    } catch (_error) {
      return null;
    }
  }

  function storeOffer(code) {
    const normalizedCode = normalizeCode(code);
    if (!normalizedCode) return null;

    const offer = { code: normalizedCode, activatedAt: Date.now() };

    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(offer));
    } catch (_error) {
      return offer;
    }

    return offer;
  }

  function clearOffer() {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (_error) {
      return;
    }
  }

  function readCookie(name) {
    const prefix = `${encodeURIComponent(name)}=`;
    const cookie = document.cookie
      .split('; ')
      .find((entry) => entry.startsWith(prefix));

    if (!cookie) return '';

    try {
      return decodeURIComponent(cookie.slice(prefix.length).replace(/\+/g, ' '));
    } catch (_error) {
      return cookie.slice(prefix.length);
    }
  }

  function requestedOffer() {
    const params = new URLSearchParams(window.location.search);

    for (const key of PARAMETER_KEYS) {
      const code = normalizeCode(params.get(key));
      if (code) return storeOffer(code);
    }

    const shopifyDiscountCode = normalizeCode(readCookie('discount_code'));
    if (shopifyDiscountCode) return storeOffer(shopifyDiscountCode);

    return readStoredOffer();
  }

  window.CalinfiOfferSession = {
    clear: clearOffer,
    get: requestedOffer,
    normalizeCode,
    set: storeOffer,
  };

  requestedOffer();
})();
